export default {
    documentsTypes: [],
    documentType: null,
    step: null
}
